import { render } from "./Menu2.vue?vue&type=template&id=dd861d9a"
import script from "./Menu2.vue?vue&type=script&setup=true&lang=js"
export * from "./Menu2.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Volumes/ext/winglet/license/grm/webpack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Menu2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dd861d9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dd861d9a', __exports__)) {
    api.reload('dd861d9a', __exports__)
  }
  
  module.hot.accept("./Menu2.vue?vue&type=template&id=dd861d9a", () => {
    api.rerender('dd861d9a', render)
  })

}


export default __exports__